/** Faixa inferior fixa. Cresce com o conteúdo (os alertas de resposta certa e
 *  errada moram aqui), mas nunca sai da base: `shrink-0` num filho de coluna
 *  flex cuja área rolável é o corpo. */
export const Footer = ({ id, children }) => (
  <div
    id={`level-play-footer${id}`}
    className="relative z-[3] w-full shrink-0 grow-0 border-0 px-4 pt-4 pb-[calc(1rem+env(safe-area-inset-bottom))]"
  >
    <div className="mx-auto flex w-full max-w-[550px] items-center gap-6">
      {children}
    </div>
  </div>
)
